"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.feesSavedStratMapping = exports.get_api_responseContainer = exports.screen_api_to_params_mapping = exports.handleResponse = exports.async_func_data = exports.axios_config = exports.base_domain = exports.getScreenFromApi = exports.NET_API = exports.NET_SCREEN = exports.CREDIT_API = exports.LIAB_SCREEN = exports.CASH_API = exports.EXP_API = exports.INCOME_API = exports.INCOMEXP_SCREEN = exports.ASSET_CAT_API = exports.ASSET_SCREEN = void 0;
var axios_1 = __importDefault(require("axios"));
var return_code_constants_1 = require("../../constants/return_code_constants");
var types_1 = require("../global/types");
var types_2 = require("../portfolio/types");
var types_3 = require("../user/types");
exports.ASSET_SCREEN = 'assets';
exports.ASSET_CAT_API = 'assets_cat';
exports.INCOMEXP_SCREEN = 'incomexp';
exports.INCOME_API = 'income';
exports.EXP_API = 'expense';
exports.CASH_API = 'cashflow';
exports.LIAB_SCREEN = 'liability';
exports.CREDIT_API = 'credit';
exports.NET_SCREEN = 'networth';
exports.NET_API = 'networth';
exports.getScreenFromApi = function (api) {
    switch (api) {
        case exports.ASSET_CAT_API:
            return exports.ASSET_SCREEN;
        case exports.INCOME_API:
            return exports.INCOMEXP_SCREEN;
        case exports.EXP_API:
            return exports.INCOMEXP_SCREEN;
        case exports.CASH_API:
            return exports.INCOMEXP_SCREEN;
        case exports.CREDIT_API:
            return exports.LIAB_SCREEN;
        case exports.NET_API:
            return exports.NET_SCREEN;
    }
};
exports.base_domain = 'https://www.plootus.com/api/';
// const base_domain = 'https://pprodemo.herokuapp.com/';
exports.axios_config = function (api, paramsOrData, method) {
    var _a;
    return (_a = {
            method: method,
            url: exports.base_domain + api
        },
        _a[method === 'post' ? 'data' : 'params'] = paramsOrData,
        _a.headers = {
            'Content-Type': 'application/json',
        },
        _a);
};
// Reusable functions
exports.async_func_data = function (apiUrl, paramsOrData, _a, method, isTokenRequired) {
    var getState = _a[0];
    if (isTokenRequired === void 0) { isTokenRequired = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var axiosConfig, response, responseData, errorCode, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    if (isTokenRequired) {
                        axios_1.default.defaults.headers.Authorization = getState().userReducer.token;
                    }
                    axiosConfig = exports.axios_config(apiUrl, paramsOrData, method);
                    return [4 /*yield*/, axios_1.default(axiosConfig)];
                case 1:
                    response = _c.sent();
                    responseData = response.data;
                    errorCode = return_code_constants_1.SUCCESS_CODE;
                    return [2 /*return*/, { responseData: responseData, errorCode: errorCode }];
                case 2:
                    error_1 = _c.sent();
                    console.log("Error in fetching " + apiUrl + " api:->" + error_1);
                    if ((_b = error_1.response) === null || _b === void 0 ? void 0 : _b.data) {
                        console.log("Error response " + JSON.stringify(error_1.response.data, null, 2));
                        return [2 /*return*/, {
                                responseData: error_1.response,
                                errorCode: error_1.response.data.errCode || error_1.response.status,
                            }];
                    }
                    console.log('Unhandled Server Error');
                    return [2 /*return*/, {
                            responseData: error_1.response,
                            errorCode: 500,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
};
// Handle Response Codes
exports.handleResponse = function (errorCode, dispatch, action) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (errorCode) {
            case return_code_constants_1.SUCCESS_CODE:
                if (action) {
                    dispatch(action);
                }
                return [2 /*return*/, return_code_constants_1.SUCCESS_CODE];
            case return_code_constants_1.INVALID_TOKEN_CODE: {
                dispatch({
                    type: types_3.GENERAL_USER_REDUCER,
                    payload: { token: null, session_expired: true },
                });
                return [2 /*return*/, return_code_constants_1.ERROR_OCCURED];
            }
            case return_code_constants_1.SERVER_ERROR: {
                dispatch({
                    type: types_1.SEND_ALERT,
                    payload: {
                        title: 'Error',
                        textContent: 'Sorry Some Error Occured.',
                    },
                });
                return [2 /*return*/, return_code_constants_1.ERROR_OCCURED];
            }
            case return_code_constants_1.SESSION_EXPIRED: {
                dispatch({
                    type: types_3.GENERAL_USER_REDUCER,
                    payload: { token: null, session_expired: true },
                });
                return [2 /*return*/, return_code_constants_1.ERROR_OCCURED];
            }
            default:
                return [2 /*return*/, errorCode];
        }
        return [2 /*return*/];
    });
}); };
var paramsToObjects = function (params) {
    var paramOb = {};
    params.map(function (param, index) {
        paramOb["param" + (index + 1)] = param;
    });
    return paramOb;
};
var getNewAccordObject = function (params1, params2, params3, params4, container, visualCont, metaData) { return ({
    level1: paramsToObjects(params1),
    level2: paramsToObjects(params2),
    level3: paramsToObjects(params3),
    level4: paramsToObjects(params4),
    container: container,
    visualCont: visualCont,
    metaData: metaData,
}); };
exports.screen_api_to_params_mapping = function (api) {
    switch (api) {
        case exports.ASSET_CAT_API:
            return getNewAccordObject(['totalI', 'container', 'isAsset', 'list3'], // level1
            ['totalP', 'providerName', 'list2'], // level2
            ['balance', 'accountName', 'accountNumber', undefined, 'list1'], // level3
            ['value', 'symbol', 'description', 'costBasis', 'lastUpdated'], // level 4
            undefined, // container
            undefined // visualCont
            );
        case exports.CREDIT_API:
            return getNewAccordObject(['totalI', 'container', 'isAsset', 'list3'], // level1
            ['totalP', 'providerName', 'list2'], // level2
            ['balance', 'accountName', 'lastUpdated', 'accountNumber', 'list1'], // level3
            [
                'amount',
                'category',
                'description',
                'categoryType',
                'transactionDate',
            ], // level 4
            undefined, // container
            undefined // visualCont
            );
        case exports.NET_API:
            return getNewAccordObject(['totalI', 'conatiner', 'isAsset', 'list3'], // level1
            ['totalP', 'providerName', 'list2'], // level2
            ['balance', 'accountName', undefined, 'accountNumber', 'list1'], // level3
            [
                // // level4
                'amount',
                'category',
                'description',
                'categoryType',
                'transactionDate',
                'value',
                'costBasis',
                'description',
                'lastUpdated',
            ], 'networth_data.0.data', // container
            'networth' // visualCont
            );
        case exports.INCOME_API:
            return getNewAccordObject(['totalC', 'category', 'categoryType', 'container', 'list'], // level1
            ['amount', 'description', 'categoryType', 'transactionDate'], // level2
            [], [], 'transaction', // container
            undefined, // visualCont
            {
                sortParams: [
                    'amount',
                    'amount',
                    'transactionDate',
                    'transactionDate',
                ],
                searchParam: 'description',
                transactionParams: paramsToObjects([
                    'amount',
                    'description',
                    'categoryType',
                    'category',
                    'transactionDate',
                ]),
            });
        case exports.EXP_API:
            return getNewAccordObject(['totalC', 'category', 'categoryType', 'container', 'list'], // level1
            ['amount', 'description', 'categoryType', 'transactionDate'], // level2
            [], [], 'transaction', // container
            undefined, // visualCont
            {
                sortParams: [
                    'amount',
                    'amount',
                    'transactionDate',
                    'transactionDate',
                ],
                searchParam: 'description',
                transactionParams: paramsToObjects([
                    'amount',
                    'description',
                    'categoryType',
                    'category',
                    'transactionDate',
                ]),
            });
        case exports.CASH_API:
            return getNewAccordObject([
                'totalMonthwise',
                'currentMonth',
                'currentYear',
                undefined,
                'transactionData',
            ], // level1
            ['amount', 'description', 'categoryType', 'transactionDate'], // level2
            [], [], 'transaction', // container
            undefined, // visualCont
            {
                searchParam: 'description',
                searchCont: 'transactionData',
            });
        default:
            return undefined;
    }
};
var get_api_params_object = function (url, otherParams) { return ({
    url: url,
    otherParams: otherParams,
}); };
var get_api_object_details = function (params, successActionType, pie_args, responseContainer, transactionApiParams, payloadCont) { return ({
    api_params: get_api_params_object.apply(void 0, params),
    successActionType: successActionType,
    pie_args: pie_args,
    responseContainer: responseContainer,
    transactionApiParams: transactionApiParams
        ? get_api_params_object.apply(void 0, transactionApiParams) : undefined,
    payloadCont: payloadCont,
}); };
exports.get_api_responseContainer = function (api) {
    switch (api) {
        case exports.ASSET_CAT_API:
            return get_api_object_details(['holding/getAssets'], types_2.GENERAL_SET_PIE_DATA, ['totalI', 'container'], undefined);
        case exports.CREDIT_API:
            return get_api_object_details(['account/getLiabilities'], types_2.GENERAL_SET_PIE_DATA, ['totalI', 'container'], undefined);
        case exports.NET_API:
            return get_api_object_details(['networth/getNetworthNested?interval=Y'], types_2.GENERAL_SET_GRAPH_DATA, [
                'networth',
                'networth',
                'networth_data.0.data',
                'networth_data.0.netTotal',
            ], undefined, undefined, 'networth');
        case exports.INCOME_API:
            return get_api_object_details(['transaction/getTransactions?category=INCOME'], types_2.GENERAL_SET_PIE_DATA, ['totalC', 'category'], 'transaction', [
                'transaction/getTransactionsByDate?category=INCOME',
                { container: 'transaction.0.transactiondata' },
            ]);
        case exports.EXP_API:
            return get_api_object_details(['transaction/getTransactions?category=EXPENSE'], types_2.GENERAL_SET_PIE_DATA, ['totalC', 'category'], 'transaction', [
                'transaction/getTransactionsByDate?category=EXPENSE',
                { container: 'transaction.0.transactiondata' },
            ]);
        case exports.CASH_API:
            return get_api_object_details(['transaction/getTransactionsByDate?category=ALL'], types_2.GENERAL_SET_GRAPH_DATA, ['amount', '0.data', '0.data', '0.totalCashFlow', 'currentMonth'], 'transaction');
        default:
            return get_api_object_details(['holding/getAssets'], types_2.GENERAL_SET_PIE_DATA, ['totalI', 'container'], undefined);
    }
};
exports.feesSavedStratMapping = function (strategy) {
    switch (strategy) {
        case 0:
            return 'superconservative';
        case 1:
            return 'conservative';
        case 2:
            return 'moderate';
        case 3:
            return 'growth';
        case 4:
            return 'supergrowth';
        default:
            return 'superconservative';
    }
};
